export default __webpack_public_path__ + "static/media/landing.2bcf1408.png";